import styled from 'styled-components';
import {
  mediaQueries,
  PHONE
} from 'bento-ordering/base/constants/mediaQueries';

const Footer = styled.footer`
  position: 'relative';
  text-align: center;
  padding-bottom: 0;
  margin-top: 20px;
  @media ${mediaQueries[PHONE]} {
    display: ${props => props.hideBrandFooterOnMobile && 'none'};
  }
`;
export default Footer;
